import { render, staticRenderFns } from "./IndexSeckillBody.vue?vue&type=template&id=77f7a83a&scoped=true&"
import script from "./IndexSeckillBody.vue?vue&type=script&lang=js&"
export * from "./IndexSeckillBody.vue?vue&type=script&lang=js&"
import style0 from "./IndexSeckillBody.vue?vue&type=style&index=0&id=77f7a83a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f7a83a",
  null
  
)

export default component.exports